import {
	Card,
	CardProps,
	Collapse,
	CollapsePanelProps,
	CollapseProps,
} from 'antd';
import { CSSProperties, ReactNode } from 'react';
import './CardPanel.css';

export type CardPanelProps = CardProps;

function CardPanel({ children, ...cardProps }: CardPanelProps) {
	return (
		<Card
			{...cardProps}
			// size="small"
			bordered={true}
			styles={{
				...cardProps.styles,
				header: {
					position: 'sticky',
					background: 'inherit',
					top: 0,
					zIndex: 10,
					...cardProps.styles?.header,
				},
				body: {
					padding: 0,
					...cardProps.styles?.body,
				},
			}}
		>
			{children}
		</Card>
	);
}

export type CardPanelContentProps = {
	title?: string;
	collapsible?: boolean;
	collapseInitialy?: boolean;
	toggleCollapse?: CollapseProps['collapsible'];
	expandIconPosition?: 'start' | 'end';
	extra?: CollapsePanelProps['extra'];
	style?: CSSProperties;
	children: ReactNode;
};

CardPanel.Content = function CardPanelContent({
	title,
	collapsible = false,
	collapseInitialy = false,
	toggleCollapse = 'header',
	expandIconPosition = 'end',
	extra,
	style,
	children,
}: CardPanelContentProps) {
	// this is ant design bug, padding area is not
	// clickable if "collapsible" prop set to "header"
	// it's works as expected if we set it to "undefined"
	const toggle = !collapsible
		? 'icon'
		: toggleCollapse === 'header'
			? undefined
			: toggleCollapse;

	if (!collapsible && !title) {
		return (
			<div
				className="dls-card-content"
				style={{
					padding: 24,
					...style,
				}}
			>
				{children}
			</div>
		);
	}

	return (
		<Collapse
			ghost
			className="dls-card-content"
			collapsible={toggle}
			expandIconPosition={expandIconPosition}
			defaultActiveKey={collapseInitialy ? [] : [0]}
			style={style}
			items={[
				{
					label: <strong>{title}</strong>,
					showArrow: collapsible,
					extra,
					children,
				},
			]}
		/>
	);
};

export default CardPanel;
